"use client";

import { useTranslations } from "next-intl";

const Copyright = () => {
  const t = useTranslations("footer");

  return (
    <div className="bg-primary py-6 text-center text-sm text-white">
      <span>
        Copyright © {new Date().getFullYear()} Grundriss Schmiede. {t("rights")}
      </span>
    </div>
  );
};

export default Copyright;
